import React, { /*useState*/ } from "react";
import { useAppDispatch, /*useAppSelector*/ } from "../../../../store/hooks";
import { changeColorValue, changeNumberValue, /*changeImageValue*/ } from "../../../../store/model";
//import { RootState } from "../../../../store/store";
import ColorInput from "../../../Palettes/Propertybar/input/colorInput";
import NumberInput from "../../../Palettes/Propertybar/input/numberInput";
//import SelectInput from "../../../Palettes/Propertybar/input/selectInput";
import {
  getColorValue,
  getNumberValue,
} from "../shapeHelper/getSetProperties";
import ShapePalette from "../ShapePalette";
import { setOperation } from "../../../../store/interaction";

export interface LineTypeOption {
  value: number,
  label: string
}
const SymbolProperyPalette = ({ symbol }: { symbol: SymbolShape }) => {
  const dispatch = useAppDispatch();


  return (
    <ShapePalette shapeId={symbol.id}>
      <div className="property__element">
        <ColorInput
          properyDisplayName={"Stroke color"}
          currentValue={getColorValue(symbol, "stroke")()}
          setValue={(input: ColorValue) => {
            console.log(input);

            const actionPayload = {
              id: symbol.id,
              propertyValue: input,
              propertyName: "stroke",
            };
            dispatch(changeColorValue(actionPayload));
          }}
        />
      </div>
      <div className="property__element">
        <div className="flex flex-col">








        </div>
      </div>
      <div className="property__element">
        <NumberInput
          propertyDisplayName="Line weight"
          currentValue={getNumberValue(symbol, "strokeWidth")}
          setValue={(number) => {
            const payload = {
              id: symbol.id,
              propertyValue: number,
              propertyName: "strokeWidth",
            };
            dispatch(changeNumberValue(payload));
          }}
        ></NumberInput>
      </div>
      <div>
        <button onClick={() => dispatch(setOperation("move"))}>Move</button>
        <button onClick={() => dispatch(setOperation("scale"))}>Scale</button>
      </div>
      {/* <div className="property__element">
        <SelectInput
          properyDisplayName="Line type"
          choiseList={lineTypes.map((i) => {
            return { label: i.name, value: i.id }
          })}
          currentValue={ //TODO setget
            image.dashID !== undefined ? {
              label: lineTypes.find(i => i.id === (image.dashID))?.name ?? "",
              value: image.dashID ?? defaultLineTypeId
            } : { label: "Not Found", value: 0 }

          }
          setValue={function (input): void {
            const payload = {
              id: image.id,
              propertyValue: input.value,
              propertyName: "dashID",
            };
            dispatch(changeNumberValue(payload))
          }}
        />
      </div> */}
    </ShapePalette>

  );
};


const createPropertyPalette = (symbol: GeometricShape) => {
  return <SymbolProperyPalette symbol={symbol as SymbolShape} />;
};

export default createPropertyPalette;
